import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const MODULES = [{
  num: '01',
  title: 'Protocolo H.E.R. — Plan de 21 días',
  subtitle: 'Sabés exactamente qué hacer cada día para acompañar esta etapa. Sin improvisar.'
}, {
  num: '02',
  title: 'Tracker Premium H.E.R. — 21 días',
  subtitle: 'Visualizá tu progreso día a día y mantenete enfocada durante las 3 semanas.'
}, {
  num: '03',
  title: 'Noche en Calma — 7 noches de ritual',
  subtitle: 'Un protocolo simple para reducir el estrés nocturno, mejorar el descanso y cortar el ciclo de antojos.'
}, {
  num: '04',
  title: 'H.E.R. Movement — 21 rutinas en casa',
  subtitle: 'Movete entre 15 y 25 minutos por día para sentirte mejor, sin gimnasio ni equipos costosos.'
}, {
  num: '05',
  title: 'Guía de compras Argentina + Meal Prep',
  subtitle: 'Resolvé qué comprar y qué cocinar para las próximas 3 semanas en pocos minutos.'
}, {
  num: '06',
  title: 'Recetario H.E.R. — 63 recetas',
  subtitle: 'Comidas simples y reales, adaptadas a ingredientes argentinos y a esta etapa de tu vida.'
}];
export function ForWhoSection() {
  // Acordeón premium de apertura única: abrir un módulo cierra el anterior.
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => setOpenIndex(prev => prev === i ? null : i);
  return <section className="bg-gradient-hero py-20 md:py-28 px-4 md:px-8" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <div className="text-center mb-10 md:mb-14" data-id="element-96">
          <p className="uppercase tracking-[0.28em] text-[#C8A870] font-semibold mb-4 text-[13px]" data-id="element-97">
            El sistema completo
          </p>

          <h2 className="font-display text-4xl md:text-5xl font-semibold text-[#F0E8D8] leading-[1.1]" data-id="element-98">
            Qué recibís{' '}
            <span className="italic text-gradient-gold" data-id="element-99">al entrar</span>
          </h2>

          <p className="mt-4 md:text-xl text-foreground/80 max-w-xl mx-auto text-[19px]" data-id="element-100">
            Todo lo que necesitás para esta etapa, en un solo lugar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative mt-12 md:mt-16 px-2 md:px-10" data-id="element-101">
          <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-102">
            <div className="w-[80%] h-[80%] rounded-full bg-gold/10 blur-[90px]" data-id="element-103" />
          </div>

          <div className="rounded-[4px] overflow-hidden border-[0.5px] border-gold/25 shadow-[0_0_60px_rgba(200,168,112,0.08),0_30px_60px_rgba(0,0,0,0.55)] bg-white/[0.02]" data-id="element-104">
            <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/blunde.png?v=1779840976" alt="Sistema completo H.E.R." loading="eager" className="w-full h-auto block" data-id="element-105" />
          </div>

          <p className="text-center mt-6 tracking-[0.18em] uppercase font-body text-[#C8A870] text-[14px]" data-id="element-106">
            El sistema completo H.E.R.
          </p>
        </motion.div>

        {/* Acordeón editorial de los 6 módulos */}
        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mt-10 md:mt-12 max-w-xl mx-auto" data-id="element-107">
          {MODULES.map((item, i) => {
          const isOpen = openIndex === i;
          return <li key={item.num} className="border-b-[0.5px] border-gold/10 last:border-0" data-id="element-108">
                <button type="button" onClick={() => toggle(i)} aria-expanded={isOpen} className="w-full flex items-center gap-3 text-left py-4 group focus:outline-none" data-id="element-109">
                  <span className="text-[13px] text-foreground/35 font-body font-medium flex-shrink-0" data-id="element-110">
                    {item.num}
                  </span>

                  <span className="flex-1 font-display text-[18px] md:text-[17px] leading-[1.35] font-medium text-[#C8A870] transition-colors duration-300 group-hover:text-[#E8D5B0]" data-id="element-111">
                    {item.title}
                  </span>

                  <motion.span animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="flex-shrink-0 text-[#C8A870]/70 group-hover:text-[#E8D5B0] transition-colors duration-300" data-id="element-112">
                    <ChevronDownIcon className="w-5 h-5" data-id="element-113" />
                  </motion.span>
                </button>

                <AnimatePresence initial={false} data-id="element-114">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-115">
                      <p className="font-body pl-7 pr-2 pb-5 -mt-1 text-[#F0E8D8] text-[16px] leading-[1.6]" data-id="element-116">
                        {item.subtitle}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </motion.ul>
      </div>
    </section>;
}